/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import { commonUtil } from '@app/utils';
import axios from 'axios';

const { baseUrl } = commonUtil.getEnv();

export const instance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface BaseResponse {
  message: string;
  status: string;
  error: boolean;
}

export interface BasePaginationPayload {
  limit: number;
  page: number;
  keyword: string;
}

export interface BasePaginationResponse extends BaseResponse {
  pagination: {
    current_page: number;
    limit: number;
    perpage_found: number;
    total_found: number;
    total_page: number;
    search: {
      paginate: {
        page: string;
        limit: string;
      };
      keyword: string;
    }
  };
}
